import { memo } from "react";

const TopbarMessageBar = memo(({ rotatingMessages = [], utilityLinks = [] }) => (
  <header className="landing-header">
    <div className="landing-topbar">
      <div className="landing-container">
        <div className="landing-topbar-messages ml-4">
          {rotatingMessages.map((msg, idx) => (
            <div key={idx} className="landing-topbar-message-item">
              {msg.type === "link" ? (
                <a href={msg.href} target="_blank" rel="noreferrer noopener" className="landing-topbar-link ">
                  <b>{msg.strong}</b> {msg.text} 
                </a>
              ) : (
                <span><b>{msg.strong}</b> {msg.text}</span>
              )}
            </div>
          ))}
        </div>
        <div className="landing-topbar-links mr-4">
          {utilityLinks.map((link, idx) => (
            <span key={link.label || idx}>
              {link.icon ? <i className={link.icon}></i> : null}
              {link.icon ? " " : ""}
              {link.href ? (
                <a href={link.href} target="_blank" rel="noreferrer noopener" className="landing-topbar-link">{link.label}</a>
              ) : (
                link.label
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  </header>
));

TopbarMessageBar.displayName = "TopbarMessageBar";

export default TopbarMessageBar;
